import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../globalInspector/axiosInstance";
import { env } from "../../../../env";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";

const baseUrl = env.REACT_APP_BASE_URL;

export const createTdsTransaction = createAsyncThunk(
  "createTdsTransaction/create",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/transactions/tds`,
        {
          tds_transaction: values,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(message);
    }
  },
);

const createTdsTransactionSlice = createSlice({
  name: "createTdsTransaction",

  initialState: {
    createTdsTransactionData: null,
    createTdsTransactionLoading: null,
    createTdsTransactionError: null,
  },

  reducers: {
    resetCreateTdsTransaction(state) {
      state.createTdsTransactionData = null;
      state.createTdsTransactionLoading = null;
      state.createTdsTransactionError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTdsTransaction.pending, (state) => {
        state.createTdsTransactionLoading = true;
        state.createTdsTransactionError = null;
        state.createTdsTransactionData = null;
      })
      .addCase(createTdsTransaction.fulfilled, (state, action) => {
        state.createTdsTransactionLoading = false;
        state.createTdsTransactionError = null;
        state.createTdsTransactionData = action.payload;
      })
      .addCase(createTdsTransaction.rejected, (state, action) => {
        state.createTdsTransactionLoading = false;
        state.createTdsTransactionError = action.payload;
        state.createTdsTransactionData = null;
      });
  },
});

export const { resetCreateTdsTransaction } = createTdsTransactionSlice.actions;
export default createTdsTransactionSlice.reducer;
